<template>
    <div>
        <h1>Page not Found</h1>
        <router-link class="back" to="/">Go Home</router-link>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
h1 {
    font-size: 2em;
    text-align: center;
    margin-top: 20vh;
}

.back {
    color: white;
    text-decoration: none;
    padding: 10px;
    font-size: 1.2em;
    transition: background-color 0.2s ease;
    background-color: #1a1a1a;
    border-radius: 5px;
    margin-bottom: 10px;
    color: white;
    border: 1px solid crimson;
}

.back:hover {
    background-color: crimson;
}
</style>